module.exports = __webpack_public_path__ + "img/icon_map_8_off_111.889924cc.png";